export const crisisManagers: TableModule = {
    name: "crisisManagers",
    route: "spa.settings.crisisManagers",
    columns: [
        {
            name: "customName",
            sortable: true,
            pageLink: true,
            mobile: true
        }, {
            name: "email",
            sortable: true
        }, {
            name: "mobile",
            sortable: true
        }, {
            name: "active",
            sortable: true,
            width: "w-[100px]",
        }
    ],
    filters: [
        {
            name: "id",
            column: "crisis_managers.id",
            type: "numeric"
        },
        {
            name: "firstname",
            column: "crisis_managers.firstname",
            type: "string",
            reduced: true
        },
        {
            name: "lastname",
            column: "crisis_managers.lastname",
            type: "string",
            reduced: true
        },
        {
            name: "email",
            column: "crisis_managers.email",
            type: "string",
            reduced: true
        },
        {
            name: "mobile",
            column: "crisis_managers.mobile",
            type: "string"
        },
        {
            name: "active",
            column: "crisis_managers.active",
            type: "boolean"
        }
    ],
    quickFilters: [{
        name: "qf_onlyActive",
        column: "crisis_managers.active",
        value: [1],
        operator: "="
    }],
    tools: [
        {
            isCreateAction: true,
            ability: ["create", "sets"]
        }
    ]
}